import React, { Fragment, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { reduxForm, Field } from 'redux-form';
import { ButtonToolbar, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import renderField from '../../../shared/components/form/RenderField';
import HourField from '../../../shared/components/form/HourField';
import Select from '../../../shared/components/form/Select';
import validate from './Validate';

const CameraForm = (props) => {
  const { t, backHandler, handleSubmit, dto, initialize, recipients } = props;

  useEffect(() => {
    initialize(dto);
  }, [dto]);

  return (
    <Fragment>
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.name')}</span>
          <div className="form__form-group-field">
            <Field
              name="name"
              type="text"
              component={renderField}
              maxLength="100"
              placeholder={t('general.placeholders.type-here')}
            />
          </div>
        </div>
        <div className="form__form-group--2_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('school_data.startTime')}
            </span>
            <div className="form_form-group-field">
              <Field name="startTime" component={HourField} />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('school_data.finalTime')}
            </span>
            <div className="form_form-group-field">
              <Field name="endTime" component={HourField} />
            </div>
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.url-camera')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="url"
              type="text"
              component={renderField}
              placeholder={t('general.placeholders.type-here')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.access')}</span>
          <div className="form__form-group-field">
            <Field
              name="relatedObjects"
              component={Select}
              isMulti
              closeMenuOnSelect={false}
              options={recipients}
              placeholder={t('general.placeholders.select')}
            />
          </div>
        </div>
        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.save')}
          </Button>
        </ButtonToolbar>
      </form>
    </Fragment>
  );
};

CameraForm.propTypes = {
  t: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  initialize: PropTypes.func.isRequired,
  recipients: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

export default reduxForm({
  form: 'CameraForm',
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
  validate,
})(withTranslation('common')(CameraForm));
